import { render, staticRenderFns } from "./stats-card.vue?vue&type=template&id=2a0389c4&scoped=true"
import script from "./stats-card.vue?vue&type=script&lang=js"
export * from "./stats-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0389c4",
  null
  
)

export default component.exports